<template>
  <div class="round-container">
    <span class="tip">回合</span>
    <div
      v-for="(item, index) in total"
      :key="item"
      :class="['round-item', index === value ? 'active' : '']"
      @click="handleClick(index)"
    >
      {{ 2 * index + 1 }}
    </div>
    <div v-if="showAdd" class="round-item add" @click="handleAddRound">
      +
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    showAdd: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick(index) {
      this.$emit("change", index);
    },
    handleAddRound() {
      this.$emit("add");
    }
  }
};
</script>

<style lang="less" scoped>
.round-container {
  display: flex;
  align-items: center;
  user-select: none;
  .tip {
    margin-right: 12px;
    color: #454545;
    font-size: 16px;
  }
  .round-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    width: 22px;
    height: 22px;
    border-radius: 6px;
    border: 1px solid #505050;
    color: #424242;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s;
    &.active {
      border: 1px solid #967a5f;
      background: rgba(150, 122, 95, 0.2);
    }
    &.add {
      color: #fff;
      line-height: 20px;
      font-weight: bold;
      font-size: 16px;
      background: #967a5f;
      border-color: #967a5f;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
